import { VideoBlock } from 'shared/components/VideoBlock';
import { ButtonLinkContainer } from '../ButtonLinkContainer';
import { caMortgageDiscountSellActivate } from 'shared/components/tracking';
import { useDeviceType } from '@cian/ui-kit';
import { useRef } from 'react';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const VideoBlockContainer: React.FC = () => {
  const device = useDeviceType();

  const playerRef = useRef<HTMLIFrameElement>(null);

  const { config } = useApplicationContext();

  const iframeLink = config.get<string>('info-subsidized-mortgage-frontend.videoIframeLink');

  if (iframeLink === null) {
    return null;
  }

  return (
    <VideoBlock
      iframeLink={iframeLink}
      playerRef={playerRef}
      device={device}
      buttonLink={
        <ButtonLinkContainer onSendCa={() => caMortgageDiscountSellActivate('video', device)}>
          Подключить скидку на ипотеку
        </ButtonLinkContainer>
      }
    />
  );
};
